import type { IdAndName } from '@/types/id-and-name'
import type { LabelAndValue } from '@/types/label-and-value'

export const parseNameAndIdToLabelAndValue = ({
  id,
  name
}: IdAndName): LabelAndValue => ({ label: name, value: id })
